"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactInputMask = _interopRequireDefault(require("react-input-mask"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

var _TextInputPropTypes = _interopRequireDefault(require("./TextInputPropTypes"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var TextInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TextInput, _Component);

  function TextInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TextInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      validationState: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInvalid", function (evt) {
      evt.preventDefault();
      var onInvalid = _this.props.onInvalid;
      var validationState = evt.currentTarget.validity;

      _this.setState({
        validationState: validationState
      });

      if (onInvalid) {
        onInvalid(validationState);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onChange", function (evt) {
      var onChange = _this.props.onChange;

      _this.setState({
        validationState: null
      });

      if (onChange) {
        onChange(evt);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(TextInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._input.getInputDOMNode().addEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.focus !== this.props.focus) {
        this._checkFocus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._input.getInputDOMNode().removeEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "_checkFocus",
    value: function _checkFocus() {
      if (this.props.focus) {
        this._input.getInputDOMNode().focus();
      }
    }
    /**
     * Getter for the input DOM element.
     *
     * @public
     * @returns {Element} - The input element.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          name = _this$props.name,
          type = _this$props.type,
          label = _this$props.label,
          placeholder = _this$props.placeholder,
          pattern = _this$props.pattern,
          required = _this$props.required,
          disabled = _this$props.disabled,
          loading = _this$props.loading,
          autoFocus = _this$props.autoFocus,
          error = _this$props.error,
          defaultValue = _this$props.defaultValue,
          icon = _this$props.icon,
          iconPosition = _this$props.iconPosition,
          helpNode = _this$props.helpNode,
          inline = _this$props.inline,
          readOnly = _this$props.readOnly,
          maxLength = _this$props.maxLength,
          min = _this$props.min,
          max = _this$props.max,
          mask = _this$props.mask,
          maskChar = _this$props.maskChar,
          additionalInputProps = _this$props.additionalInputProps,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur;
      var validationState = this.state.validationState;
      var isValid = validationState ? validationState.valid : true;
      var classes = (0, _classnames.default)('TextInput', 'FormElement', {
        'FormElement-inline': inline
      }, {
        'FormElement-with-icon': icon
      }, {
        'FormElement-loading': loading
      }, (0, _defineProperty2.default)({}, "FormElement-with-icon-".concat(iconPosition), icon), {
        'FormElement-contains-error': !isValid
      }, className);
      return _react.default.createElement("div", {
        className: classes
      }, label, _react.default.createElement("div", {
        className: "FormElement-control"
      }, _react.default.createElement(_reactInputMask.default, (0, _extends2.default)({
        ref: function ref(node) {
          _this2._input = node;
        },
        className: "FormElement-item",
        name: name,
        type: type,
        placeholder: placeholder,
        disabled: disabled,
        autoFocus: autoFocus,
        required: required,
        pattern: pattern,
        maxLength: maxLength,
        min: min,
        max: max,
        onChange: this._onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        mask: mask,
        maskChar: maskChar,
        alwaysShowMask: false,
        readOnly: readOnly,
        defaultValue: defaultValue
      }, additionalInputProps)), icon, loading && _react.default.createElement(_Loader.default, {
        size: 16,
        borderWidth: 2
      })), helpNode && _react.default.createElement("div", {
        className: "FormElement-help-text"
      }, helpNode), !isValid && error);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "node",
    get: function get() {
      return this._input.getInputDOMNode();
    }
  }]);
  return TextInput;
}(_react.Component);

exports.default = TextInput;
(0, _defineProperty2.default)(TextInput, "propTypes", _TextInputPropTypes.default);
(0, _defineProperty2.default)(TextInput, "defaultProps", {
  type: 'text',
  maskChar: null,
  iconPosition: 'left'
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TextInput, "TextInput", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/TextInput/TextInput.jsx");
  leaveModule(module);
})();

;